import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.2426 4.75736C10.8995 2.41421 7.10051 2.41421 4.75736 4.75736C2.41422 7.10049 2.41421 10.8995 4.75736 13.2426C7.10049 15.5858 10.8995 15.5858 13.2426 13.2426C15.5858 10.8995 15.5858 7.10051 13.2426 4.75736ZM3.6967 3.6967C6.62563 0.767768 11.3744 0.767766 14.3033 3.6967C17.2322 6.62563 17.2322 11.3744 14.3033 14.3033C11.3744 17.2322 6.62562 17.2322 3.6967 14.3033C0.767767 11.3744 0.767766 6.62562 3.6967 3.6967ZM6.34858 10.591C6.64147 10.2981 7.11634 10.2981 7.40924 10.591C8.28791 11.4697 9.71253 11.4697 10.5912 10.591C10.8841 10.2981 11.359 10.2981 11.6519 10.591C11.9448 10.8839 11.9448 11.3588 11.6519 11.6517C10.1874 13.1161 7.81304 13.1161 6.34857 11.6517C6.05568 11.3588 6.05568 10.8839 6.34858 10.591Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.875 7.125C7.875 7.74632 7.45527 8.25 6.9375 8.25C6.41973 8.25 6 7.74632 6 7.125C6 6.50368 6.41973 6 6.9375 6C7.45527 6 7.875 6.50368 7.875 7.125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 7.125C12 7.74632 11.5803 8.25 11.0625 8.25C10.5447 8.25 10.125 7.74632 10.125 7.125C10.125 6.50368 10.5447 6 11.0625 6C11.5803 6 12 6.50368 12 7.125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }